import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router';

import {
    Button,
    Anchor,
    Flex,
    Text,
    TextButton,
    Spacer,
} from '@zillow/constellation';

import analyticsUtils from 'app/client/utils/analyticsUtils';
import AnalyticsConstants from 'app/shared/constants/AnalyticsConstants';
import ModalActions from 'app/shared/actions/ModalActions';
import { RMWContext } from 'app/shared/providers/RMWContext';

import { StyledContainer, StyledIcon, StyledCenterContainer } from './StyledComponents';

const PostDeactivationModal = ({ location }) => {
    const dispatch = useDispatch();
    const { paths } = useContext(RMWContext);

    const handleCollectRentClick = () => {
        const { pathname } = location;
        const listingId = pathname.split('/')[3];
        const paymentsPathname = `${paths.base}/payments/properties/${listingId}`;

        dispatch(analyticsUtils.track.GAEventV2(
            AnalyticsConstants.GA_EVENTS.POST_DEACTIVATION_MODAL_COLLECT_RENT_CLICK
        ));

        const params = '?itc=ZRM_Listing_Deactivated_Modal&acceptTerms=true';
        const onboardingPath = `${paymentsPathname}/onboarding/payment-settings${params}`;
        window.router.updateLocation(onboardingPath);
    };

    const handleDontNeedClick = () => {
        dispatch(analyticsUtils.track.GAEventV2(
            AnalyticsConstants.GA_EVENTS.POST_DEACTIVATION_MODAL_DONT_NEED_CLICK
        ));
        dispatch(ModalActions.hideModal());
    };

    return (
        <StyledCenterContainer>
            <Spacer marginBottom="md" marginTop="sm">
                <Flex display="flex" justifyContent="center">
                    <StyledIcon size="lg" />
                </Flex>
                <Text fontType="h4">Your listing is deactivated</Text>
                <Spacer marginY="sm">
                    <Text>We are removing your listing from Zillow, Trulia and HotPads.</Text>
                </Spacer>
            </Spacer>
            <StyledContainer>
                <Text fontType="h6">Now make sure you&#39;re paid on time!</Text>
                <Spacer marginBottom="sm">
                    <Text>
                        Collect rent online with Zillow Rental Manager. It&#39;s easy, quick and free.
                    </Text>
                </Spacer>
                <Spacer marginBottom="sm">
                    <Flex display="flex" justifyContent="center">
                        <Button buttonType="primary" onClick={handleCollectRentClick}>
                            Start collecting rent
                        </Button>
                    </Flex>
                </Spacer>
                <Text as="div" fontType="legal">
                    By clicking &quot;Start collecting rent&quot; you agree to comply with the&nbsp;
                    <Anchor href={paths.corpTermsURL} target="_blank">
                        Terms of Use
                    </Anchor>
                    ,&nbsp;
                    <Anchor href={paths.rentalTermsURL} target="_blank">
                        Rental User Terms
                    </Anchor>
                    , and our third-party payment processor&apos;s&nbsp;
                    <Anchor href={paths.paymentTermsURL} target="_blank">
                        Payment Terms
                    </Anchor>
                    &nbsp;and&nbsp;
                    <Anchor href={paths.bankAuthorizationTermsURL} target="_blank">
                        Bank Authorization Terms
                    </Anchor>
                    .
                </Text>
            </StyledContainer>
            <Spacer marginTop="xs" marginBottom="lg">
                <Flex display="flex" justifyContent="center">
                    <TextButton onClick={handleDontNeedClick} fontType="bodySmall">
                        I don&#39;t need online rent payments at this time
                    </TextButton>
                </Flex>
            </Spacer>
        </StyledCenterContainer>
    );
};

export default withRouter(PostDeactivationModal);
